module.exports = __webpack_public_path__ + "static/media/stats-bars4.6efd09de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/stats-bars4.svg
// module id = 3605
// module chunks = 7